module.exports = __webpack_public_path__ + "static/media/player_user_types.606cf22a.png";